module.exports = __webpack_public_path__ + "static/media/data-logo.592a06b6.svg";